import { Link } from "react-router-dom";

export default function Child({ child }) {
  return (
    <>
      <li>Nome: {child.guardianName}</li>
      <ul>
        <li>Tel.: {child.phone}</li>
        <li>Cel.: {child.cellphone}</li>
        <li>Email: {child.email}</li>
        <li>
          <b>Aluno: </b>
          <Link to="/consultaralunos">
            {child.firstName} {child.lastName}
          </Link>
        </li>
        <hr></hr>
      </ul>
    </>
  );
}
